import {observer} from 'mobx-react';
import {DashboardEditModel} from '../model/DashboardEditModel.mdl';
import {useModuleFactory} from '@injex/react-plugin';
import {useParams} from 'react-router-dom';
import {useEffect} from 'react';
import PageMessageLoader from '../../../../../common/components/page-message-loader/PageMessageLoader';
import {DashboardsListWithContext} from '../../../list/context/DashboardsListContext';
import DashboardEditForm from '../components/DashboardEditForm';

export default observer(function DashboardEdit() {

    const model = useModuleFactory<DashboardEditModel>('dashboardEditModel');
    const {id} = useParams<{ id: string; }>();

    useEffect(() => {
        model.item.invalidate().fetch(id);
    }, [model, id]);
    useEffect(() => {
        const hook = model.reportingMetaDataManager.hooks.timePresetChange;
        hook.tap(model.onFetchCompleted);
        return () => hook.untap(model.onFetchCompleted);
    }, [model]);

    return (
        <DashboardsListWithContext>
            {model.item.isLoading ? (
                <PageMessageLoader title="Loading Dashboard" description="Please wait..."/>
            ) : model.item.error || !model.item.data ? (
                <div role="alert">Failed to load dashboard.</div>
            ) : (
                <DashboardEditForm model={model}/>
            )}
        </DashboardsListWithContext>
    );
});
